const clean = (v) => {
  let s = v.replace(/[^0-9.]/g, "");
  const i = s.indexOf(".");
  if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
  return s;
};

export const NumField = ({ id, label, value, onChange, prefix, suffix, placeholder, hint }) => (
  <label className="field" htmlFor={id}>
    <span className="field-label">{label}</span>
    <span className="field-box">
      {prefix && <span className="field-affix">{prefix}</span>}
      <input
        id={id}
        data-testid={`input-${id.replace(/_/g, "-")}`}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(clean(e.target.value))}
      />
      {suffix && <span className="field-affix">{suffix}</span>}
    </span>
    {hint && <span className="field-hint">{hint}</span>}
  </label>
);
